module.exports = __webpack_public_path__ + "img/certificate-template.ba3f6e6a.jpg";